import { useContext, useEffect, useRef, useState } from 'react'
import Logo from '../../assets/images/logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Preloader from '../../whatsapp/small_component/preloader';
import Swalaleart from '../../whatsapp/function/swalaleart';
import { saveToken } from '../../whatsapp/function/token';
import { useDispatch } from 'react-redux';
import { setAccessToken } from '../../redux/tokenslice';
import { ToastContainer } from 'react-toastify';
import Cookies from 'js-cookie';
import { faEnvelope, faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { faKey, faUser, faShieldAlt, faChartLine, faRocket } from '@fortawesome/free-solid-svg-icons';
import Singup from '../../whatsapp/small_component/singup';
import { theme } from '../Theme/ThemeContext';
import { ThemeContext } from '../../routing/ApplicationRouting';
import domain from '../../reusecomponent/domain';

const GMB_GREEN = '#075E54';
const GMB_GREEN_LIGHT = '#128C7E';
const GMB_GREEN_PALE = '#e8f5e9';

export default function Login() {
    const navigate = useNavigate();
    const eye = useRef();
    const [loder, setloder] = useState(false);
    const [eyeVisible, setEyeVisible] = useState(false);
    const dispatch = useDispatch();
    const userInformation = useRef({ 'email': null, 'password': null, 'user_role': 'Owner' })
    useEffect(() => {
        userInformation.current.email = Cookies.get('email');
        userInformation.current.password = Cookies.get('password');
        userInformation.current.user_role = Cookies.get('user_role');
        console.log(userInformation.current.user_role);
        document.body.classList.add('login-page');
        return () => {
            document.body.classList.remove('login-page');
        };
    }, []);

    const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
        initialValues: {
            email: userInformation.current.email !== null ? userInformation.current.email : '',
            password: userInformation.current.password !== null ? userInformation.current.password : '',
            user_role: userInformation.current.user_role !== null ? userInformation.current.user_role : 'Owner',
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            email: Yup.string().email('Please Enter Valid Email').required('Please Enter Your Email'),
            password: Yup.string().min(8, 'Please Enter Valid Password').required('Please Enter Your Password'),
            user_role: Yup.string().oneOf(['Owner', 'Agent']).nullable(),
        }),
        onSubmit: async (values) => {
            try {
                setloder(true);
                const res = await fetch(`${domain()}/login`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email: values.email,
                        password: values.password,
                        user_role: (values.user_role && values.user_role.trim()) ? values.user_role : 'Owner'
                    }),
                }
                );
                if (!res.ok) {
                    setloder(false);
                    Swalaleart({ title: "Error", text: "Internal Server Problem", icon: "error", });
                }
                const response = await res.json();
                if (response) {
                    setloder(false);
                    if (response.status) {
                        if (values.rememberMe) {
                            Cookies.set('email', values.email, { expires: 90 });
                            Cookies.set('password', values.password, { expires: 90 });
                            Cookies.set('user_role', values.user_role, { expires: 90 });
                        }
                        saveToken(response.data);
                        dispatch(setAccessToken(response.data));
                        Swalaleart({ title: "Success", text: response.message, icon: "success", confirmcolor: '#1fee5b' });
                        navigate('/client-area');
                    } else {
                        Swalaleart({ title: "Failed", text: response.message, icon: "warning", });
                    }
                }
            } catch (error) {
                setloder(false);
                Swalaleart({ title: "Error", text: "Network Error", icon: "error", });
            }
        }
    });

    const passowrdvisible = () => {
        if (eye.current.type === 'password') {
            eye.current.type = 'text';
        } else {
            eye.current.type = 'password';
        }
    }

    return (
        <>
            <ToastContainer newestOnTop={false} rtl={false} pauseOnFocusLoss />
            <Preloader action={loder} />
            <div style={{
                minHeight: '100vh',
                background: `linear-gradient(135deg, ${GMB_GREEN} 0%, ${GMB_GREEN_LIGHT} 50%, #0d9488 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: '"Outfit", "Inter", sans-serif',
                padding: '20px',
            }}>
                {/* Decorative background blobs */}
                <div style={{
                    position: 'fixed', top: '-80px', right: '-80px', width: 320, height: 320,
                    borderRadius: '50%', background: 'rgba(255,255,255,0.06)', pointerEvents: 'none'
                }} />
                <div style={{
                    position: 'fixed', bottom: '-60px', left: '-60px', width: 240, height: 240,
                    borderRadius: '50%', background: 'rgba(255,255,255,0.04)', pointerEvents: 'none'
                }} />

                <style>{`
              @media (max-width: 768px) {
                .login-card-container {
                  flex-direction: column !important;
                  max-width: 450px !important;
                }
                .login-brand-panel {
                  display: none !important;
                }
                .login-form-panel {
                  border-radius: 24px !important;
                  padding: 24px 20px !important;
                }
              }
            `}</style>

                <div className="login-card-container" style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    maxWidth: 680,
                    borderRadius: 24,
                    overflow: 'hidden',
                    boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
                    background: '#fff',
                    minHeight: 'auto',
                }}>
                    {/* Left brand panel */}
                    <div className="login-brand-panel" style={{
                        width: 240,
                        minWidth: 220,
                        background: `linear-gradient(160deg, ${GMB_GREEN} 0%, ${GMB_GREEN_LIGHT} 100%)`,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '36px 20px',
                        position: 'relative',
                        overflow: 'hidden',
                    }}>
                        {/* Decorative circles */}
                        <div style={{
                            position: 'absolute', top: -40, left: -40, width: 160, height: 160,
                            borderRadius: '50%', background: 'rgba(255,255,255,0.08)',
                        }} />
                        <div style={{
                            position: 'absolute', bottom: -30, right: -30, width: 120, height: 120,
                            borderRadius: '50%', background: 'rgba(255,255,255,0.06)',
                        }} />
                        {/* Logo */}
                        <img src={Logo} alt="logo" style={{
                            maxWidth: 160, width: '70%', height: 'auto',
                            marginBottom: 32, filter: 'brightness(0) invert(1)',
                            position: 'relative', zIndex: 1,
                        }} />
                        <h2 style={{
                            color: '#fff', fontWeight: 700, fontSize: 22, marginBottom: 12,
                            textAlign: 'center', position: 'relative', zIndex: 1, lineHeight: 1.3,
                        }}>
                            Welcome Back! 👋
                        </h2>
                        <p style={{
                            color: 'rgba(255,255,255,0.8)', fontSize: 14, textAlign: 'center',
                            lineHeight: 1.6, position: 'relative', zIndex: 1, marginBottom: 32,
                        }}>
                            Your all-in-one CRM for managing WhatsApp campaigns, contacts, and customer conversations.
                        </p>
                        {/* Feature bullets */}
                        <div style={{ position: 'relative', zIndex: 1, width: '100%' }}>
                            {[
                                { icon: faShieldAlt, text: 'Secure & Encrypted' },
                                { icon: faChartLine, text: 'Campaign Analytics' },
                                { icon: faRocket, text: 'Auto Responders' },
                            ].map((f, i) => (
                                <div key={i} style={{
                                    display: 'flex', alignItems: 'center', gap: 10,
                                    marginBottom: 10, color: 'rgba(255,255,255,0.9)', fontSize: 13,
                                }}>
                                    <div style={{
                                        width: 28, height: 28, borderRadius: 8,
                                        background: 'rgba(255,255,255,0.18)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                    }}>
                                        <FontAwesomeIcon icon={f.icon} style={{ fontSize: 11 }} />
                                    </div>
                                    {f.text}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right form panel */}
                    <div className="login-form-panel" style={{
                        flex: 1,
                        background: '#fff',
                        padding: '28px 28px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}>
                        <div style={{ marginBottom: 20 }}>
                            <h2 style={{
                                fontWeight: 800, fontSize: 20, color: '#1a202c',
                                marginBottom: 4, letterSpacing: '-0.3px',
                            }}>Sign In</h2>
                            <p style={{ color: '#6b7280', fontSize: 12, margin: 0 }}>
                                Enter your credentials to access your account
                            </p>
                        </div>

                        <form onSubmit={handleSubmit} autoComplete="on">
                            {/* Email */}
                            <div style={{ marginBottom: 14 }}>
                                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5 }}>
                                    Email Address
                                </label>
                                <div style={{
                                    display: 'flex', alignItems: 'center', gap: 0,
                                    border: `1.5px solid ${errors.email && touched.email ? '#ef4444' : '#e2e8f0'}`,
                                    borderRadius: 10, overflow: 'hidden', background: '#f9fafb',
                                    transition: 'border-color 0.2s',
                                }}>
                                    <span style={{
                                        width: 42, height: 42, minWidth: 42,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        background: GMB_GREEN_PALE, color: GMB_GREEN,
                                        borderRight: `1.5px solid #e2e8f0`,
                                        fontSize: 13,
                                        flexShrink: 0,
                                    }}>
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    </span>
                                    <input
                                        type="email"
                                        style={{
                                            flex: 1, minWidth: 0, height: 42, border: 'none', outline: 'none',
                                            padding: '0 12px', fontSize: 13, background: 'transparent',
                                            color: '#1a202c',
                                        }}
                                        onChange={handleChange} onBlur={handleBlur}
                                        value={values.email} name='email' id="loginEmail"
                                        placeholder="Enter email address" autoComplete="username"
                                    />
                                </div>
                                {errors.email && touched.email && (
                                    <p style={{ color: '#ef4444', fontSize: 11, marginTop: 3, marginBottom: 0 }}>
                                        {errors.email}
                                    </p>
                                )}
                            </div>

                            {/* Password */}
                            <div style={{ marginBottom: 14 }}>
                                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5 }}>
                                    Password
                                </label>
                                <div style={{
                                    display: 'flex', alignItems: 'center',
                                    border: `1.5px solid ${errors.password && touched.password ? '#ef4444' : '#e2e8f0'}`,
                                    borderRadius: 10, overflow: 'hidden', background: '#f9fafb',
                                }}>
                                    <span style={{
                                        width: 42, height: 42, minWidth: 42,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        background: GMB_GREEN_PALE, color: GMB_GREEN,
                                        borderRight: `1.5px solid #e2e8f0`,
                                        fontSize: 13,
                                        flexShrink: 0,
                                    }}>
                                        <FontAwesomeIcon icon={faKey} />
                                    </span>
                                    <input
                                        type="password"
                                        style={{
                                            flex: 1, minWidth: 0, height: 42, border: 'none', outline: 'none',
                                            padding: '0 12px', fontSize: 13, background: 'transparent',
                                            color: '#1a202c',
                                        }}
                                        onChange={handleChange} onBlur={handleBlur}
                                        value={values.password} name='password' id="loginPassword"
                                        ref={eye} placeholder="Enter password" autoComplete="current-password"
                                    />
                                    {/* Eye toggle — styled like left icon pad */}
                                    <span
                                        onClick={() => {
                                            setEyeVisible(v => !v);
                                            passowrdvisible();
                                        }}
                                        style={{
                                            width: 42, height: 42, minWidth: 42,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            background: GMB_GREEN_PALE, color: GMB_GREEN,
                                            borderLeft: `1.5px solid #e2e8f0`,
                                            cursor: 'pointer',
                                            flexShrink: 0,
                                            fontSize: 13,
                                            transition: 'background 0.15s',
                                            userSelect: 'none',
                                        }}
                                        onMouseOver={e => e.currentTarget.style.background = '#d1fae5'}
                                        onMouseOut={e => e.currentTarget.style.background = GMB_GREEN_PALE}
                                        title={eyeVisible ? "Hide password" : "Show password"}
                                    >
                                        <FontAwesomeIcon icon={eyeVisible ? faEyeSlash : faEye} />
                                    </span>
                                </div>
                                {errors.password && touched.password && (
                                    <p style={{ color: '#ef4444', fontSize: 11, marginTop: 3, marginBottom: 0 }}>
                                        {errors.password}
                                    </p>
                                )}
                            </div>

                            {/* Role */}
                            <div style={{ marginBottom: 18 }}>
                                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5 }}>
                                    Login As
                                </label>
                                <div style={{
                                    display: 'flex', alignItems: 'center',
                                    border: '1.5px solid #e2e8f0',
                                    borderRadius: 10, overflow: 'hidden', background: '#f9fafb',
                                }}>
                                    <span style={{
                                        width: 42, height: 42, minWidth: 42,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        background: GMB_GREEN_PALE, color: GMB_GREEN,
                                        borderRight: `1.5px solid #e2e8f0`,
                                        fontSize: 13,
                                        flexShrink: 0,
                                    }}>
                                        <FontAwesomeIcon icon={faUser} />
                                    </span>
                                    <select
                                        style={{
                                            flex: 1, minWidth: 0, height: 42, border: 'none', outline: 'none',
                                            padding: '0 12px', fontSize: 12, background: 'transparent',
                                            color: '#1a202c', cursor: 'pointer',
                                        }}
                                        onChange={handleChange} onBlur={handleBlur}
                                        value={values.user_role} name='user_role' id="userRole"
                                    >
                                        <option value="Owner">Owner</option>
                                        <option value="Agent">Agent</option>
                                    </select>
                                </div>
                            </div>

                            {/* Remember / Forgot */}
                            <div style={{
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                marginBottom: 18,
                            }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: 7, cursor: 'pointer', fontSize: 12, color: '#6b7280' }}>
                                    <input
                                        type="checkbox" id='rememberMe'
                                        onChange={handleChange} onBlur={handleBlur} name='rememberMe'
                                        style={{ width: 14, height: 14, accentColor: GMB_GREEN, cursor: 'pointer' }}
                                    />
                                    Remember me
                                </label>
                                <Link to="/forgot-password" style={{
                                    fontSize: 12, color: GMB_GREEN, fontWeight: 600, textDecoration: 'none',
                                }}>
                                    Forgot password?
                                </Link>
                            </div>

                            {/* Submit */}
                            <button
                                type="submit"
                                style={{
                                    width: '100%', height: 42, border: 'none', borderRadius: 10,
                                    background: `linear-gradient(90deg, ${GMB_GREEN} 0%, ${GMB_GREEN_LIGHT} 100%)`,
                                    color: '#fff', fontSize: 12, fontWeight: 700,
                                    cursor: 'pointer', letterSpacing: 0.5,
                                    boxShadow: `0 4px 16px rgba(7,94,84,0.35)`,
                                    transition: 'transform 0.15s, box-shadow 0.15s',
                                }}
                                onMouseOver={e => {
                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                    e.currentTarget.style.boxShadow = `0 6px 20px rgba(7,94,84,0.45)`;
                                }}
                                onMouseOut={e => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = `0 4px 16px rgba(7,94,84,0.35)`;
                                }}
                            >
                                SIGN IN
                            </button>

                            {/* Singup — same height and style as SIGN IN, navy blue */}
                            <div style={{ marginTop: 12 }}>
                                <Singup setloder={setloder} />
                            </div>
                        </form>
                    </div>
                </div>

                {/* Responsive styles */}
                <style>{`
                @media (max-width: 680px) {
                    .login-split-left { display: none !important; }
                    .login-split-right { border-radius: 24px !important; }
                }
            `}</style>
            </div>
        </>
    )
}
